import { useEffect, useRef, useState } from 'react';

/*
 * Custom hook for detecting if an element is in view
 * Returns a ref to attach to the element and a boolean indicating if it's in view
 * or close to being in view (based on rootMargin and threshold).
 * rootMargin: CSS margin-like string to expand or contract the bounding box of the root
 * threshold: A number (between 0 and 1) that defines what fraction of the target’s bounding box must be visible before the callback fires.
 * Cleans up observer on unmount
 */
const useElementInView = ({ root = null, rootMargin = '0px', threshold = 0 } = {}) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting), { root, rootMargin, threshold });
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [root, rootMargin, threshold]);

  return [ref, inView];
};

export default useElementInView;
